// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__27Jva","studyBtn":"styles_studyBtn__AQ-E6"};